import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.css';

document.querySelectorAll('select[id^="select"]:not([id^="select-page"])')
    .forEach(element => {
        new Choices(element, {
            searchEnabled: true,
            searchPlaceholderValue: 'Suchen …',
            itemSelectText: '',
            shouldSort: false,
            noResultsText: 'Kein Ergebnis gefunden',
        });
    });

document.querySelectorAll('select[id^="select-page"]')
    .forEach(element => {
        new Choices(element, {
            searchEnabled: true,
            searchPlaceholderValue: 'Bankensuche …',
            itemSelectText: '',
            shouldSort: true,
            noResultsText: 'Bank wurde nicht gefunden',
        });
    });